// extracted by mini-css-extract-plugin
export var alignDiscLeft = "r_q4 d_fp d_bG d_dv";
export var alignLeft = "r_qh d_fp d_bG d_dv";
export var alignDiscCenter = "r_q5 d_fq d_bD d_dw";
export var alignCenter = "r_bP d_fq d_bD d_dw";
export var alignDiscRight = "r_q6 d_fr d_bH d_dx";
export var alignRight = "r_qj d_fr d_bH d_dx";
export var footerContainer = "r_q7 d_dW d_bW";
export var footerContainerFull = "r_q8 d_dT d_bW";
export var footerHeader = "r_kf d_kf";
export var footerTextWrapper = "r_q9 d_w";
export var footerDisclaimerWrapper = "r_km d_km d_ck";
export var badgeWrapper = "r_rb d_w d_bz d_bP d_bF d_bJ";
export var verticalTop = "r_rc d_bz d_bJ d_bN d_bL";
export var wide = "r_rd d_cy";
export var right = "r_rf d_bK";
export var line = "r_fk d_fl d_cv";
export var badgeDisclaimer = "r_rg d_bC d_bP d_bJ";
export var badgeContainer = "r_rh d_bz d_bH d_bP";
export var badge = "r_rj";
export var padding = "r_rk d_c7";
export var end = "r_rl d_bH";
export var linkWrapper = "r_rm d_dB";
export var link = "r_mC d_dB";
export var colWrapper = "r_rn d_cx";
export var consent = "r_f d_f d_bC d_bP";
export var disclaimer = "r_rp d_bz d_bJ";
export var media = "r_rq d_bx d_dy";
export var itemRight = "r_rr";
export var itemLeft = "r_rs";
export var itemCenter = "r_rt";
export var exceptionWeight = "r_rv y_sH";